import { render, staticRenderFns } from "./MobileSwiper.vue?vue&type=template&id=87f41112&scoped=true"
import script from "./MobileSwiper.vue?vue&type=script&lang=ts"
export * from "./MobileSwiper.vue?vue&type=script&lang=ts"
import style0 from "./MobileSwiper.vue?vue&type=style&index=0&id=87f41112&prod&scoped=true&lang=css"
import style1 from "./MobileSwiper.vue?vue&type=style&index=1&id=87f41112&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f41112",
  null
  
)

export default component.exports